import {useState} from 'react';
import {setDoc, collection, doc} from "firebase/firestore";
import {ref, uploadBytesResumable, getDownloadURL} from "firebase/storage";
import { db, storage } from '../firebase';
import pic from "../img/info.png";
import {useHistory} from "react-router-dom";
export default function Info({user, isUser, userProv}) {

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [img, setImg] = useState();

    const history = useHistory();
    if(!isUser){
        history.push("/login")
    }
    
    if(userProv == "google.com"){
        history.push("/")
    }

    async function handleSubmit(e){
        e.preventDefault();
        if(!img) return;
        const name = `users/${String(new Date().getTime()) + img.name}`;
        const storageRef = ref(storage, name);
        const uploadTask = uploadBytesResumable(storageRef, img);

        uploadTask.on("state_changed", () => {}, (err) => {
            console.log(err.code)
        }, () => {
            getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                setDoc(doc(db, "users", user.uid), {
                    firstName: firstName,
                    lastName: lastName,
                    img: String(url)
                }).then(() => {
                    alert("Profile Updated Successfully 💖");
                })
            })
        })
    }
  return (
    <div className='info-page'>
        <div className='left'><img src = {pic}/></div>
        <div className='right '>
            <form onSubmit={handleSubmit}>
                <h2>Tell us about Yourself</h2>
                <label>First Name</label>
                <input type = "text" value={firstName} onChange = {e => setFirstName(e.target.value)} required/>
                <label>Last Name</label>
                <input type = "text" value={lastName} onChange = {e => setLastName(e.target.value)} required/>
                <label>Profile Image</label>
                <input type = "file" accept='image/*' onChange={e => setImg(e.target.files[0])} required/>
                <button>Save</button>
            </form>
        </div>
    </div>
  )
}
